import React, { useReducer, useContext } from "react";
import usuariosReducer from "./usuariosReducer";
import usuariosContext from "./usuariosContext";
import authContext from "../authentication/authContext";

import {
    getAllUsers as getAllUsersAPI,
    addUser as addUserAPI,
    updateUser as updateUserAPI,
    deleteUser as deleteUserAPI
} from "../../api/user";

import {
    GET_USUARIOS,
    ADD_USUARIO,
    UPDATE_USUARIO,
    DELETE_USUARIO,
    SET_LOADING,
    SET_ERROR
} from "./usuariosActions";

const UsuariosState = props => {

    const initialState = {
        usuarios: [],
        loading: false,
        error: null
    };

    const [state, dispatch] = useReducer(usuariosReducer, initialState);
    const aContext = useContext(authContext);

    const getAllUsers = async () => {
        try {
            dispatch({ type: SET_LOADING, payload: true });
            const response = await getAllUsersAPI();
            dispatch({
                type: GET_USUARIOS,
                payload: response.data.data
            });
            return response.data.data;
        } catch (error) {
            console.log("Error en getAllUsers", error);
            dispatch({ type: SET_ERROR, payload: error.message });
        }
    };

    const addUser = async (user) => {
        try {
            dispatch({ type: SET_LOADING, payload: true });
            const response = await addUserAPI(user, aContext.usuario);
            dispatch({
                type: ADD_USUARIO,
                payload: response.data.data
            });
            return response.data.data;
        } catch (error) {
            console.log("Error en addUser", error);
            dispatch({ type: SET_ERROR, payload: error.message });
            throw error;
        }
    };

    const updateUser = async (user) => {
        try {
            dispatch({ type: SET_LOADING, payload: true });
            const response = await updateUserAPI(user);
            dispatch({
                type: UPDATE_USUARIO,
                payload: response.data.data
            });
            return response.data.data;
        } catch (error) {
            console.log("Error en updateUser", error);
            dispatch({ type: SET_ERROR, payload: error.message });
            throw error;
        }
    };

    const deleteUser = async (user) => {
        try {
            dispatch({ type: SET_LOADING, payload: true });
            const response = await deleteUserAPI(user);
            dispatch({
                type: DELETE_USUARIO,
                payload: user
            });
            return response.data.data;
        } catch (error) {
            console.log("Error en deleteUser", error);
            dispatch({ type: SET_ERROR, payload: error.message });
            throw error;
        }
    };

    return (
        <usuariosContext.Provider
            value={{
                usuarios: state.usuarios,
                loading: state.loading,
                error: state.error,
                getAllUsers,
                addUser,
                updateUser,
                deleteUser
            }}
        >
            {props.children}
        </usuariosContext.Provider>
    );
};

export default UsuariosState;
